import React, { useState, useEffect } from 'react'
import styled from 'styled-components'
import { devices } from '../../Tool-kit/styles/mediaQueries'
import Footer from '../Footer'
import Header from '../Header'
import ReactGA from 'react-ga'
import { useLocation } from 'react-router'

const MainPanel = ({ children }) => {
  const [isMobileNav, setIsMobileNav] = useState(false)
  const location = useLocation()
  useEffect(() => {
    ReactGA.set({ page: location.pathname })
    ReactGA.pageview(location.pathname)
  }, [location])

  return (
    <>
      <Header isMobileNav={isMobileNav} setIsMobileNav={setIsMobileNav} />
      <Container isMobileNav={isMobileNav}>
        <Body>{children}</Body>
        <Footer />
      </Container>
    </>
  )
}

export default MainPanel

const Container = styled.div`
  @media ${devices.tabport} {
    overflow-y: ${({ isMobileNav }) => (isMobileNav ? 'hidden' : 'auto')};
    height: ${({ isMobileNav }) => (isMobileNav ? `calc(100vh - 9rem)` : '')};
  }
`
const Body = styled.div`
  min-height: calc(100vh - 320px);
  position: relative;
`
